import { QueryParamsHandling } from '@angular/router';

import { TooltipOptions } from 'primeng/api';

import { GridApi, IHeaderParams } from 'ag-grid-enterprise';

import { ISummitGroupEvent } from './i-summit-group-event';
import { ISummitHeaderMenuItem } from './i-summit-header-menu-item';
import { SummitIdObject } from './summit-id-object';

export class SummitHeaderMenuItem<T extends SummitIdObject> implements ISummitHeaderMenuItem<T> {
  //adding callbacks
  disabledCallback?: (api: GridApi, elements: T[]) => boolean;
  visibleCallback?: (api: GridApi, elements: T[]) => boolean;

  //MenuItem properties
  label?: string;
  icon?: string;
  command?: (event?: ISummitGroupEvent<T>) => void;
  url?: string;
  items?: ISummitHeaderMenuItem<T>[];
  expanded?: boolean;
  disabled?: boolean;
  visible?: boolean;
  target?: string;
  escape?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routerLinkActiveOptions?: any;
  separator?: boolean;
  badge?: string;
  tooltip?: string;
  tooltipPosition?: string;
  badgeStyleClass?: string;
  style?:
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any;
      }
    | null
    | undefined;
  styleClass?: string;
  title?: string;
  id?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  automationId?: any;
  tabindex?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routerLink?: any;
  queryParams?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [k: string]: any;
  };
  fragment?: string;
  queryParamsHandling?: QueryParamsHandling;
  preserveFragment?: boolean;
  skipLocationChange?: boolean;
  replaceUrl?: boolean;
  iconStyle?:
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any;
      }
    | null
    | undefined;
  iconClass?: string;
  state?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [k: string]: any;
  };
  tooltipOptions?: TooltipOptions;

  //Static Functions
  static applyCallBacks<T extends SummitIdObject>(
    item: ISummitHeaderMenuItem<T>,
    api: GridApi,
    elements: T[],
    disableAll: boolean
  ): ISummitHeaderMenuItem<T> {
    if (disableAll) item.disabled = true;
    else if (item.disabled === undefined && item.disabledCallback) item.disabled = item.disabledCallback(api, elements);
    if (item.visible === undefined && item.visibleCallback) item.visible = item.visibleCallback(api, elements);
    return item;
  }

  static setElements<T extends SummitIdObject>(
    items: ISummitHeaderMenuItem<T>[],
    params: IHeaderParams,
    elements?: Array<T>,
    disableAll?: boolean
  ): ISummitHeaderMenuItem<T>[] {
    if (!items) return [];
    if (!elements) {
      elements = [];
      params.api.forEachNodeAfterFilter((row) => {
        if (elements) elements.push(row.data);
      });
    }
    const lclMulti = items.map((item) => Object.assign({}, item));
    lclMulti.map((item) => {
      const oldCommand = item.command;
      if (oldCommand) {
        item.command = ($event: ISummitGroupEvent<T>) => {
          //Inject properties into event
          $event.elementIds = [];
          params.api.forEachNodeAfterFilter((row) => {
            $event.firstChild ??= row?.data;
            if (row?.data?.id) $event.elementIds.push(row.data.id);
          });
          //$event.element = elements[0];
          if (oldCommand) oldCommand($event);
        };
      }
      SummitHeaderMenuItem.applyCallBacks(item, params.api, elements ?? [], disableAll ?? false);
      if (item.items) item.items = SummitHeaderMenuItem.setElements(item.items, params, elements, disableAll);
    });
    return lclMulti;
  }
}
